<template>
 
  <span class="product-item-extra sly-item" v-on:click="inputChange" v-bind:class="{ 'multi-select' : selectionType == 1, 'selected' : quantity > 0, 'buyButtonDisabled' : product.buyButtonDisabled }">
    <label>
      <span class="product-item-extra-inner">

        <span v-if="product.content.photos != null" class="image-container" :style="{ backgroundImage: `url('${product.content.photos[0]}')` }"></span>
        <span v-else class="image-container"></span>

        <span v-if="selectionType === 'radio'" class="radiobox" v-bind:class="quantity ? 'active' : '' ">
          <i class="icon icon-radio"></i>
        </span>
        <span v-else class="checkbox" v-bind:class="quantity ? 'active' : '' ">
          <i class="icon icon-check"></i>
        </span>
        <span class="caption">{{product.name}}</span><span v-if="product.price.priceInclTax > 0" class="price">(+ {{product.price.priceInclTax | toCurrency}})</span>
      </span>
    </label>
  </span>

</template>

<script>
  import { services } from '../Services/Services'

  export default {

    props: { 'productId': Number, 'selectionType': String, 'listIndex': Number, "quantity" : Number },

    computed: {
      product: function () {
        return services.getProductExtra(this.productId);
      }
    },
    methods: {
      inputChange: function (event) {

        if (this.product.buyButtonDisabled) {
          return;
        }

        /// this.quantity = this.quantity === 0 ? 1 : 0;
        // toggle function
        this.$emit('extra-quantity-changed', { extraQuantity: (!this.quantity || this.quantity == 0) ? 1 : 0, extraId: this.productId, selectionType : this.selectionType });
      }
    },
  
    created: function() {
      if (this.product.content.preselected && !this.product.buyButtonDisabled) {
        this.quantity = 1;
        this.$emit('extra-quantity-changed', { extraQuantity: 1, extraId: this.productId, selectionType: this.selectionType });
      }
    }
  }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/order-item-extra.vue